module.exports = __webpack_public_path__ + "static/media/round-spinner.93136162.svg";